import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { styled } from "@mui/material/styles";
import { useHistory } from "react-router-dom";
import { TablePagination } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
		fontWeight: "bold",
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 14,
		fontWeight: "bold",
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
		fontWeight: "bold",
	},
	"&:last-child td, &:last-child th": {
		border: 0,
		fontWeight: "bold",
	},
}));
function Row(props) {
	const { row } = props;
	const [open, setOpen] = React.useState(false);
	const history = useHistory();
	return (
		<React.Fragment>
			<StyledTableRow>
				<TableCell>
					<IconButton
						aria-label="expand row"
						size="small"
						onClick={() => setOpen(!open)}
					>
						{open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
					</IconButton>
				</TableCell>
				<TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
					{row.id}
				</TableCell>
				<TableCell component="th" scope="row" style={{ fontWeight: "bold" }}>
					{row.shipCharge}
				</TableCell>
				<TableCell style={{ fontWeight: "bold" }}>{row.subTotal}</TableCell>
				<TableCell style={{ fontWeight: "bold" }}>{row.total}</TableCell>
				<TableCell align="right" style={{ fontWeight: "bold" }}>
					{new Date(row.createdAt).toDateString()}
				</TableCell>
			</StyledTableRow>
			<StyledTableRow>
				<TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
					<Collapse in={open} timeout="auto" unmountOnExit>
						<Box sx={{ margin: 1 }}>
							<Typography
								variant="h6"
								gutterBottom
								component="div"
								style={{ fontWeight: "bold" }}
							>
								Campaign
							</Typography>
							<Table size="small" aria-label="purchases">
								<TableHead>
									<TableRow>
										<TableCell style={{ fontWeight: "bold" }}>
											Product
										</TableCell>
										<TableCell style={{ fontWeight: "bold" }}>Color</TableCell>
										<TableCell style={{ fontWeight: "bold" }}>Size</TableCell>
										<TableCell style={{ fontWeight: "bold" }}>
											Quantity
										</TableCell>
										<TableCell style={{ fontWeight: "bold" }}>Price</TableCell>
										<TableCell style={{ fontWeight: "bold" }}>Total</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{row.items.map((camp) => (
										<TableRow
											key={camp.campaignId}
											sx={{ cursor: "pointer" }}
											onClick={() =>
												history.push({
													pathname: `/compaigndetail/${camp.campaignId}`,
													state: { isAdmin: true },
												})
											}
										>
											<TableCell
												component="th"
												scope="row"
												sx={{
													display: "flex",
													alignItems: "center",
													fontWeight: "bold",
												}}
											>
												<img src={camp?.designShirt} alt="shirt" width={100} />
												<Typography
													component="span"
													sx={{
														textTransform: "capitalize",
														fontWeight: "bold",
													}}
												>
													{camp.shirtName}
												</Typography>
											</TableCell>
											<TableCell>
												<Typography
													sx={{
														background: camp.colors,
														height: 30,
														width: 100,
													}}
												/>
											</TableCell>
											<TableCell style={{ fontWeight: "bold" }}>
												{camp.size}
											</TableCell>
											<TableCell style={{ fontWeight: "bold" }}>
												{camp.quantity}
											</TableCell>
											<TableCell style={{ fontWeight: "bold" }}>
												{camp.price}
											</TableCell>
											<TableCell style={{ fontWeight: "bold" }}>
												{camp.price * camp.quantity}
											</TableCell>
										</TableRow>
									))}
								</TableBody>
							</Table>
						</Box>
					</Collapse>
				</TableCell>
			</StyledTableRow>
		</React.Fragment>
	);
}

Row.propTypes = {
	row: PropTypes.shape({
		calories: PropTypes.number.isRequired,
		carbs: PropTypes.number.isRequired,
		fat: PropTypes.number.isRequired,
		history: PropTypes.arrayOf(
			PropTypes.shape({
				amount: PropTypes.number.isRequired,
				customerId: PropTypes.string.isRequired,
				date: PropTypes.string.isRequired,
			}),
		).isRequired,
		name: PropTypes.string.isRequired,
		price: PropTypes.number.isRequired,
		protein: PropTypes.number.isRequired,
	}).isRequired,
};

export default function CollapsibleTable({ payments, searchKey }) {
	const [page, setPage] = React.useState(0);
	const [rows, setRows] = React.useState([]);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	React.useEffect(() => {
		setRows(payments);
	}, [payments]);

	const filterArray = () =>
		rows?.filter((val) => {
			if (searchKey === "") {
				return val;
			} else if (
				Object.values(val)
					?.join(" ")
					?.toLowerCase()
					?.includes(searchKey?.toLowerCase())
			) {
				return val;
			}
		});
	return payments?.length ? (
		<>
			<TableContainer component={Paper}>
				<Table aria-label="collapsible table">
					<TableHead>
						<TableRow>
							<StyledTableCell />
							<StyledTableCell>Order ID</StyledTableCell>
							<StyledTableCell>Ship Charge</StyledTableCell>
							<StyledTableCell>Sub Total</StyledTableCell>
							<StyledTableCell>Total</StyledTableCell>
							<StyledTableCell align="right">Created At</StyledTableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{filterArray().length ? (
							filterArray()
								.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
								.map((row) => <Row key={row.name} row={row} />)
						) : (
							<Typography
								sx={{
									position: "absolute",
									top: "50%",
									left: "50%",
								}}
							>
								No data found
							</Typography>
						)}
					</TableBody>
				</Table>
			</TableContainer>
			<TablePagination
				component="div"
				count={rows?.length}
				onPageChange={handleChangePage}
				onChangeRowsPerPage={handleChangeRowsPerPage}
				page={page}
				rowsPerPage={rowsPerPage}
				rowsPerPageOptions={false}
			/>
		</>
	) : (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "80vh",
			}}
		>
			<Typography component="h1" variant="h6">
				No Data Found
			</Typography>
		</Box>
	);
}
